<template>
  <div class="upload">
    <div class="imgOver fL marR20" v-for="(item, key) in fileList" :key="key">
      <a class="zoom zoom-in">
        <video class="imgupload" controls="controls" :src="item.url" autoplay></video>
      </a>
      <i class="el-icon-error dele" v-if="!inputCard.options.disabled && item.status !=2" @click="handleFileRemove(item, key)" />
    </div>
    <!-- 上传中的样式 -->
    <div v-if="!pass && progress !== 0" class="imgOver fL marR20 imgupload">
      <div class="maskBg" :style="'height: ' + progress * 100 + '%;'"></div>
      <div class="num">{{ parseInt(progress * 100) }}%</div>
    </div>
    <div id="global-uploader">
      <!-- 上传 -->
      <uploader
        ref="uploader"
        v-if="!inputCard.options.disabled"
        :options="options"
        :autoStart="false"
        @file-added="onFileAdded"
        @files-added="onFilesAdded"
        @file-success="onFileSuccess"
        @file-progress="onFileProgress"
        @file-error="onFileError"
        class="avatar-uploader fL marR20"
        style="padding-top: 0px; margin-bottom: -10px"
      >
        <uploader-unsupport></uploader-unsupport>
        <uploader-btn id="global-uploader-btn" ref="uploadBtn" :attrs="attrs">
          <i class="el-icon-circle-plus-outline add_size" />
          <em>点击上传</em>
          <p>支持MP4/MOV格式，大小不超过500M</p>
        </uploader-btn>
      </uploader>
      <!-- <video width="500" height="200" controls="controls" autoplay src="http://intra-d.sinastorage.com/weiboadsjucai/17b14755e9fa4d7f9c1cd0443ee932b7.mov" /> -->
    </div>
  </div>
</template>

<script>
import { getData, saveData } from "../../utils/utils";
export default {
  name: "simple-uploader",
  data() {
    return {
      options: {
        target: "/api/file/split/upload",
        singleFile: true,
        forceChunkSize: true,
        chunkSize: "5120000", //5M
        fileParameterName: "file",
        categoryMap: { accept: [".mp4", ".mov"] },
        // 仅在404的情况下 文件失败
        permanentErrors: ["404"],
        maxChunkRetries: 3,
        allowDuplicateUploads: true, //允许上传同一文件
        testChunks: false, //是否开启服务器分片校验
        initialPaused: true, //初始文件 paused 状态
        withCredentials: true,
        processParams(params, file, chunk) {
          //请求前参数format
          return {
            originFileName: params.filename,
            splitTotal: params.totalChunks,
            currentSplitId: params.chunkNumber,
            uploadId: file.uniqueIdentifier,
          };
        },
      },
      attrs: { accept: ".mp4,.mov" },
      progress: 0, // 上传进度
      pass: null, // 是否上传成功
      loadIntrval: null,
      uploadEnable: true,
    };
  },
  components: {},
  props: {
    inputKey: String,
    onError: {
      type: Function,
      default: () => {},
    },
    onProgress: {
      type: Function,
      default: () => {},
    },
    inputCard: Object,
    onSuccess: {
      type: Function,
      default: () => {},
    },
    onPreview: {
      type: Function,
      default: () => {},
    },
    onRemove: {
      type: Function,
      default: () => {},
    },
    fileList: Array,
  },
  watch: {},
  computed: {
    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
  },
  methods: {
    onFilesAdded(files) {},
    onFileAdded(file) {
      if (!this.uploadEnable) {
        this.$message.warning("请等待上一个文件上传完成");
        file.ignored = true;
        // file.cancel();
        return false;
      }
      if (file.size > 500 * 1024 * 1024) {
        this.$message.warning("文件大小不能超过500M");
        file.ignored = true;
        // file.cancel();
        return false;
      } else {
        if (!file.paused) {
          file.pause();
        }
        this.pass = false;
        this.progress = 0;
        clearInterval(this.loadIntrval);
        // 获取文件唯一标识
        this.getFileIdentifier(file);
      }
    },
    getFileIdentifier(file) {
      getData(
        "/api/file/split/upload/id",
        {
          fileName: file.name,
          fileSize: file.size,
        },
        (response) => {
          if (response.code == 0 && response.data) {
            file.uniqueIdentifier = response.data;
            file.resume();
          }
        }
      );
    },
    onFileProgress(rootFile, file, chunk) {
      clearInterval(this.loadIntrval);
      this.uploadEnable = false;
      this.progress = file.progress();
      if (this.progress < 1) {
        this.loadIntrval = setInterval(() => {
          if (this.progress < 1) {
            this.progress = file.progress();
          }
        }, 10);
      }
    },
    onFileSuccess(rootFile, file, res, chunk) {
      clearInterval(this.loadIntrval);
      this.uploadEnable = true;
      this.progress = 1;
      this.pass = true;
      const response = JSON.parse(res);
      if (response.code == 0) {
        if (response.data) {
          saveData(
            "/api/file/split/merge",
            {
              uploadId: file.uniqueIdentifier,
              originFileName: file.name,
            },
            (response) => {
              this.fileList.push({
                url: response.data.httpurl,
                name: response.data.filename,
              });
              this.$emit("validate-upload", this.inputKey);
            },
            (error) => {
              this.$message.warning("上传文件失败");
            }
          );
        }
      }
    },
    onFileError(rootFile, file, response, chunk) {
      clearInterval(this.loadIntrval);
      this.uploadEnable = true;
      this.pass = true;
      this.progress = 0;
      var msg = "上传文件错误";
      try {
        msg = JSON.parse(response).msg || "上传文件错误";
      } catch (e) {}
      this.$message.warning(msg);
    },
    handleFileRemove: function (file, i) {
      // 删除图片
      if (!file.url) {
        return false;
      }
      this.fileList.splice(i, 1);
    },
  },
  mounted() {},
};
</script>

<style>
#global-uploader-btn {
  border: 1px solid #e1e6f1;
  background: #f9fafd;
  border-radius: 0;
  text-align: center;
  width: 280px;
  height: 210px;
}
#global-uploader-btn .add_size {
  font-size: 40px;
  color: #bbc0d5;
  padding: 66px 0 20px;
  line-height: 0;
}
#global-uploader-btn:hover .add_size {
  color: #2a60e4;
}
#global-uploader-btn em {
  font-style: normal;
  color: #07175d;
  display: block;
  line-height: 20px;
  padding-top: 12px;
  font-size: 14px;
  font-family: PingFangSC-Regular, Hiragino Sans GB, Microsoft YaHei,
    \\5FAE\8F6F\96C5\9ED1, Arial, sans-serif;
}
#global-uploader-btn p {
  font-size: 12px;
  color: #c4c9da;
  line-height: 20px;
  padding-top: 3px;
  font-family: PingFangSC-Regular, Hiragino Sans GB, Microsoft YaHei,
    \\5FAE\8F6F\96C5\9ED1, Arial, sans-serif;
}
.imgupload {
  width: 280px;
  height: 210px;
}
.imgOver {
  width: 280px;
  height: 210px;
  background-color: #f9fafd;
  border: 1px solid #e1e6f1;
  position: relative;
  overflow: hidden;
  margin-top: 0px;
}
.upload .imgOver .dele {
  background: #fff;
  position: absolute;
  color: rgba(0, 0, 0, 0.3);
  right: 10px;
  top: -20px;
  width: 14px;
  height: 14px;
  text-align: center;
  line-height: 14px;
  border-radius: 50%;
  transition: all 0.3s ease 0s;
}
.add_size {
  font-size: 40px;
  color: #bbc0d5;
  padding: 66px 0 20px;
  line-height: 0;
}

.upload .imgOver .num {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
}

.upload .imgOver .maskBg {
  width: 100%;
  height: 0;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  bottom: 0;
  text-align: center;
  cursor: pointer;
}
.upload .imgOver .mask {
  width: 100%;
  height: 0;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  bottom: 0;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease 0s;
}
.zoom {
  display: inline-block;
}
.zoom-in {
  cursor: zoom-in;
}
.zoom-out {
  cursor: zoom-out;
}
.upload .imgOver:hover .dele {
  top: 10px;
}
.upload .el-upload-dragger:hover {
  background: #f9fafd;
}
.fontW {
  color: #fff;
  font-size: 14px;
  font-family: "PingFangSC-Medium", "Microsoft YaHei", "微软雅黑", Arial,
    sans-serif;
}

.again.fontW:hover {
  color: #2a60e4;
  /*cursor: default;*/
}
</style>


// WEBPACK FOOTER //
// src/components/form/SimpleUploader.vue